//import _ from 'lodash';
import { connect } from 'react-redux';
import {
	getProjectedMonthly,
	getUpToDateMonthly,
	getPriorWeek,
	getCurrentMonthly,
	getPriorMondayThroughFriday,
} from '../modules/report';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state) => {
	let projectedMonthly = undefined;
	let upToDateMonthly = undefined;
	let priorWeek = undefined;
	let currentMonthly = undefined;
	let priorMondayThroughFriday = undefined;

	if (state.report.projectedMonthly) {
		projectedMonthly = state.report.projectedMonthly;
	}

	if (state.report.upToDateMonthly) {
		upToDateMonthly = state.report.upToDateMonthly;
	}

	if (state.report.priorWeek) {
		priorWeek = state.report.priorWeek;
	}

	if (state.report.priorMondayThroughFriday) {
		priorMondayThroughFriday = state.report.priorMondayThroughFriday;
	}

	if (state.report.currentMonthly) {
		currentMonthly = state.report.currentMonthly;
	}

	return {
		currentMonthly,
		projectedMonthly,
		upToDateMonthly,
		priorWeek,
		priorMondayThroughFriday,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getCurrentMonthly,
			getProjectedMonthly,
			getUpToDateMonthly,
			getPriorWeek,
			getPriorMondayThroughFriday,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
